<template>
  <div
    class="h-screen flex flex-col bg-slate-20 w-full overflow-hidden"
    v-loading="loading"
  >
    <div class="flex flex-1 w-full overflow-hidden">

      <Sidebar />

      <!-- MAIN -->
      <div
        class="main-content flex flex-col flex-1 min-h-0 transition-all duration-300"
        :class="!isSBPin ? 'ml-17' : 'ml-62.5 cursor-pointer lg:cursor-default'"
      >
        <Navigation />

        <!-- SCROLL AREA -->
        <div ref="scrollContainer" class="flex-1 min-h-0 overflow-y-auto">

          <div
            v-if="!route.meta.isDarkBackground"
            class="flex items-center py-1"
          ></div>

          <router-view v-slot="{ Component }">
            <component
              :is="Component"
              :class="{
                'py-1.25 px-4 md:px-7.5 lg:px-6.2':
                  !route.meta.isFullWidthLayout
              }"
            />
          </router-view>

        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="w-full z-10 relative">
      <Footer />
    </div>

    <!-- COOKIES -->
    <div class="w-full z-50 relative">
      <CookiesBanner />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, nextTick } from 'vue'
import useStore from 'store'
import { useRoute, useRouter } from 'vue-router'
import { HomeFilled } from '@element-plus/icons-vue'

export default defineComponent({
  name: 'Layout',

  components: {
    HomeFilled,
  },

  setup() {
    const route: any = useRoute()
    const router = useRouter()
    const store = useStore()

    const scrollContainer = ref<HTMLElement | null>(null)

    const isSBPin = computed(() => store.dashboard.isSBPin)
    const loading = computed(() => store.global.loading)

    const setIsSBPin = (b: boolean) =>
      store.dashboard.setIsSBPin(b)

    router.afterEach(async () => {
      await nextTick()

      scrollContainer.value?.scrollTo({
        top: 0,
        behavior: 'auto',
      })
    })

    return {
      isSBPin,
      loading,
      setIsSBPin,
      route,
      scrollContainer,
    }
  },
})
</script>

<style scoped>
.main-content {
  @apply transition-all duration-300;
}

@media screen and (max-width: 1023px) {
  .main-content {
    margin-left: 0 !important;
  }
}
</style>